module.exports = __webpack_public_path__ + "media/images/chara-general-3dd00c379ab4c2fc7a7bfe5f2d667314.png";